module.exports = __webpack_public_path__ + "static/img/jigou-xinjiang-top.863fa65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-xinjiang-top.png
// module id = pG+z
// module chunks = 2